import { Mapper, FirestoreEntity } from '../../../@harmony';
import { Timestamp } from 'firebase/firestore';
import { FormerUserEntity, UserEntity } from '../../data/entities/user.entity';
import { FormerUser, User } from '../models/user.model';

export class UserToUserEntityMapper implements Mapper<User, FirestoreEntity<UserEntity>> {
  public map(from: User): FirestoreEntity<UserEntity> {
    return new FirestoreEntity(from.id, {
      _version: 0,
      createdAt: Timestamp.fromDate(from.createdAt),
      email: from.email,
      capabilities: from.capabilities,
      displayName: from.displayName,
      givenName: from.givenName,
      familyName: from.familyName,
      firstLogin: from.firstLogin ? Timestamp.fromDate(from.firstLogin) : undefined,
      lastLogin: from.lastLogin ? Timestamp.fromDate(from.lastLogin) : undefined,
      lastLoginProvider: from.lastLoginProvider,
      lastLoginProviderUserId: from.lastLoginProviderUserId,
      teamId: from.teamId,
      teamInvite: from.teamInvite,
    });
  }
}

export class UserEntityToUserMapper implements Mapper<FirestoreEntity<UserEntity>, User> {
  public map(from: FirestoreEntity<UserEntity>): User {
    return new User(
      from.id,
      from.data.createdAt.toDate(),
      from.data.email,
      from.data.capabilities,
      from.data.displayName,
      from.data.givenName,
      from.data.familyName,
      from.data.firstLogin?.toDate(),
      from.data.lastLogin?.toDate(),
      from.data.lastLoginProvider,
      from.data.lastLoginProviderUserId,
      from.data.teamId,
      from.data.teamInvite,
    );
  }
}

export class FormerUserEntityToFormerUserMapper
  implements Mapper<FirestoreEntity<FormerUserEntity>, FormerUser>
{
  public map(from: FirestoreEntity<FormerUserEntity>): FormerUser {
    return new FormerUser(
      from.id,
      from.data.removedAt.toDate(),
      from.data.email,
      from.data.displayName,
    );
  }
}
